import { render, staticRenderFns } from "./teacherTimetable.vue?vue&type=template&id=1264453b&scoped=true&"
import script from "./teacherTimetable.vue?vue&type=script&lang=js&"
export * from "./teacherTimetable.vue?vue&type=script&lang=js&"
import style0 from "./teacherTimetable.vue?vue&type=style&index=0&lang=less&"
import style1 from "./teacherTimetable.vue?vue&type=style&index=1&id=1264453b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1264453b",
  null
  
)

export default component.exports